import React, {Suspense, lazy} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {FallbackView} from '../../_metronic/partials'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import ProcessesPage from '../modules/processes/ProcessesPage';
import ReportsPage from '../modules/reports/ReportsPage';

export function PrivateRoutes() {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const AdminPage = lazy(()=> import('../modules/admin/AdminPage'))

  return (
    <Suspense fallback={<FallbackView />}>
      <Switch>
        <Route path='/dashboard' component={DashboardWrapper} />
        <Route path='/crafted/pages/profile' component={ProfilePage} />
        <Route path='/crafted/pages/wizards' component={WizardsPage} />
        <Route path='/crafted/widgets' component={WidgetsPage} />
        <Route path='/crafted/account' component={AccountPage} />
        <Route path='/apps/chat' component={ChatPage} />
        <Route path='/administration' component={AdminPage} />
        <Route path='/processes' component={ProcessesPage} />
        <Route path='/reports' component={ReportsPage}/>
        <Route path='/menu-test' component={MenuTestPage} />
        <Redirect from='/auth' to='/administration' />
        <Redirect exact from='/' to='/administration' />
        <Redirect to='error/404' />
      </Switch>
    </Suspense>
  )
}
